import React, {Component} from 'react';
import {
  Container,
  Divider,
  Header,
  Image,
  Menu,
}                         from 'semantic-ui-react';
import _                  from 'lodash';
import ReactHtmlParser    from 'react-html-parser';
import PropTypes          from 'prop-types';

// Global
import getMessage         from '../../global/getMessage';
// Controller
import globalController   from '../../global/globalcontroller';

// Images
// import Gaelle             from '../../images/gaelle.jpeg';
// import GaelleSing         from '../../images/aCES_8523.png';
import GaelleSing2        from '../../images/aCES_8608.jpg';
// Style
import                    '../MainStyle/MainTwo.scss';
import                    './MainsAbout.scss';

const propTypes = {
  content : PropTypes.arrayOf(PropTypes.object),
  lang    : PropTypes.shape({menu: PropTypes.object}),
};
const defaultProps = {
  content : null,
  lang    : {},
};

class MainsAbout extends Component {

  constructor(props) {
    super(props);
    this.handleItemCLick = this.handleItemCLick.bind(this);
    this.state = {active: 0};
  }

  handleItemCLick(e,v) {
    this.setState({active: v.index});
  }

  render() {
    const {
      content,
      lang,
    } = this.props;
    content; // es lint happy - Keep it as we may want to be able to force content from parent

    const menuItems = [
      {
        active  : this.state.active === 0,
        content : getMessage('section.sabout.menu.formation',lang),
        key     : 'formation',
        icon    : 'microphone',
      },
      {
        active  : this.state.active === 1,
        content : getMessage('section.sabout.menu.professorat',lang),
        key     : 'professorat',
        icon    : 'comment',
      },
      {
        active  : this.state.active === 2,
        content : getMessage('section.sabout.menu.stage',lang),
        key     : 'stage',
        icon    : 'music',
      },
    ];

    const contents = {};
    menuItems.forEach((menu, i) => {
      if (menu.content.length) {
        contents[i] = [];
        const contentMsg = getMessage(`section.sabout.${menu.content[0].toLowerCase()}`, lang);
        _.forOwn(contentMsg, (value, key) => {
          contents[i].push(
            <p key={key}>
              {value}
            </p>
          );
        });
      }
    });

    return (
      <Container className='sgr-mainHome-grid-two-sub'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>

            <Image
              avatar
              size='small'
              src={GaelleSing2}
            />

            {ReactHtmlParser(getMessage('section.about.header.title', lang))}
          </Header.Content>
          <Header.Subheader>
            {ReactHtmlParser(getMessage('section.about.header.subTitle',lang))}
          </Header.Subheader>
        </Header>

        <br />
        <Menu
          attached='top'
          items={menuItems}
          onItemClick={this.handleItemCLick}
          tabular
        />

        {contents[this.state.active]}

      </Container>
    );
  }

}

MainsAbout.propTypes = propTypes;
MainsAbout.defaultProps = defaultProps;

export default globalController(MainsAbout);



// WEBPACK FOOTER //
// ./src/organisms/MainsAbout/MainsAbout.js